/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sportdeelname_Api_Errors_Sport_Already_ExistsInputs */

const nl_sportdeelname_api_errors_sport_already_exists = /** @type {(inputs: Sportdeelname_Api_Errors_Sport_Already_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deze sport staat al bij de leerling`)
};

/**

* @param {Sportdeelname_Api_Errors_Sport_Already_ExistsInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const sportdeelname_api_errors_sport_already_exists = /** @type {((inputs?: Sportdeelname_Api_Errors_Sport_Already_ExistsInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sportdeelname_Api_Errors_Sport_Already_ExistsInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_sportdeelname_api_errors_sport_already_exists(inputs)
});
export { sportdeelname_api_errors_sport_already_exists as "sportdeelname.api_errors.sport_already_exists" }